export enum TimeReportType {
  Common = "Common",
  OnCall = "OnCall",
  PassiveOnCall = "PassiveOnCall",
  PreparednessA = "PreparednessA",
  ActivePreparednessAPeriod = "ActivePreparednessAPeriod",
  PreparednessB = "PreparednessB",
  ActivePreparednessBPeriod = "ActivePreparednessBPeriod",
  SickDay = "SickDay",
  VabDay = "VabDay"
}

export enum TimeReportWorkType {
  Work = "Work",
  OnCall = "OnCall",
  PreparednessA = "PreparednessA",
  PreparednessB = "PreparednessB"
}

export enum TimeReportTemplateType {
  Basic = "Basic",
  KronobergLakare = "KronobergLakare",
  KronobergSSK = "KronobergSSK",
  DalarnaLakare = "DalarnaLakare",
  GotlandLakare = "GotlandLakare",
  GotlandSSK = "GotlandSSK",
  BlekingeLakare = "BlekingeLakare",
  BlekingeSSK = "BlekingeSSK",
  OstergotlandLakare = "OstergotlandLakare",
  OstergotlandSSK = "OstergotlandSSK",
  GavleborgLakare = "GavleborgLakare",
  HallandSSK = "HallandSSK",
  HallandLakare = "HallandLakare"
}
